export const styles = (theme) => ({
        active: {
          background: "#656565",
          color:"#fff",
        },
    playerContainer:{
        width:"410px",
        margin:"0 auto",
        display:"flex",
        alignItems: "center",
        justifyContent: "center",
        padding:"3px 0 5px 90px",
        position:"relative",

        // Added Breakpoints
    [theme.breakpoints.down("sm")]: {
        width:"360px",
        padding:"3px 0 5px 0px",
      },
      [theme.breakpoints.up("md")]: {
        width:"400px",
        padding:"8px 0 5px 10px",
        margin:"0"
      },
  
      [theme.breakpoints.up("lg")]: {
        width:"100%",
        padding:"8px 0 0px 10px",
        margin:"0",
        maxWidth:"86%"
      },

        
    },
    PlayerControls:{
        width:"35px",
        padding:"0 10px 0 0px",
        "& .MuiCircularProgress-colorPrimary" :{
          color: "#ffffff",
          width: "20px !important",
          height: "20px !important",
      },
    },
    PlayerProgress:{
       width:"100%",
       padding:"0 ",
       height: "34px",
       overflow: "hidden",
       "&.popupPlayerProgress":{
        height: "50px",
        "& .MuiLinearProgress-colorPrimary":{
          height: "60px",
        }
       }
    },
    PlayerVolume:{
        width:"auto",
        display: "flex",
    },
    PlayerControlsBg:{
        background:"#0C853E",
        padding: "5px",
        width:"25px",
        height:"25px",
        "& svg":{
            fontSize:"16px"
        },
        "&:hover":{
            opacity: ".8",
            background: "#0C853E",
        }
    },
    DisabledPlayerControlsBg:{
        background:"#353535",
        color: "#808080",
    },
    NowPlaying:{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "100%",
        display: "block",
        fontSize: "14px",
        fontWeight: "600",
    },
    CurrentPlaying:{
    color:"#35c370",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "100%",
    display: "block",
    fontSize: "11px",
    fontWeight: "600",
    margin:"1px 0",
    },
    RepeatIcon:{
    padding:"0 10px",
    },
    playerDownload: {
        fontSize: "14px",
        "& .MuiButton-contained": {
            boxShadow: "none",
            background: " #0C853E",
            border: "1px solid #0C853E",
            lineHeight: "31px",
            fontSize: "14px",
            minWidth: "30px",
            margin: "5px ",
            padding: "0",
            height: "30px",
            borderRadius: "4px",
          },
        "& .MuiButton-contained:hover": {
          opacity: ".8",
          color: "#fff",
          background: " #0C853E",
        },
       "& svg":{
           fontSize:"16px",
       }
     
      },
      trackName:{
          width:"100%",
          overflow: "hidden",
      },
      PlayerPlaylist:{
        "& .MuiCircularProgress-colorPrimary":{
          width: "20px !important",
          height: "20px !important",
          color: "#ffffff",
        }
      },
      PlayListQuickLink:{
        color: "#fff",
        display: "flex",
        marginBottom: "10px",
        "& > div":{
          marginLeft: "10px",
          "& > span":{
            display:"block",
          }
        },
        "&:hover":{
          textDecoration:"underline",
        },
      },
      playlistType: {
        fontSize: "11px",
      color: "#ccc",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      },
      playlistTypeCatName: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "150px",
    fontSize: "12px",
      },
      playlistName: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "150px",
     fontSize:"1em",
      },
      popOutBlock:{
        "& .hideInside":{
          display:"none",
        },
        fontSize: "14px",
        "& button": {
            boxShadow: "none",
            background: " #0C853E",
            border: "1px solid #0C853E",
            lineHeight: "31px",
            fontSize: "14px",
            minWidth: "30px",
            margin: "5px",
            padding: "0",
            height: "30px",
            borderRadius: "4px",
          },
        "& button:hover": {
          opacity: ".8",
          color: "#fff",
          background: " #0C853E",
        },
       "& svg":{
           fontSize:"16px",
       }
      }
});
